import { api } from "./api";

interface GetShowResultsRequest {
  date?: Temporal.PlainDate | null;
  showTypeId?: string;
}

export const getShowResults = async ({
  date,
  showTypeId,
}: GetShowResultsRequest): Promise<any> => {
  const params = new URLSearchParams();
  if (date) params.append("date", date.toString());
  if (showTypeId) params.append("showTypeId", encodeURIComponent(showTypeId));
  const url = `/showresults`;
  const { data } = await api.get<object>(
    params ? `${url}?${params.toString()}` : url
  );

  return data;
};

export default {
  getShowResults,
};
